import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { NextPanel } from 'src/app/models/next-panel';
import { EnrollmentBenefitCategory } from '../models/enrollment-category';

const controllerRoute = '/waive-category';

@Injectable()
export class EnrollmentWaiveService {

    constructor(
        private apiService: ApiService,
    ) {
    }

    public initializeSerivce(): Observable<NextPanel> {
        return this.apiService.post(`${controllerRoute}/initialize`, null).pipe(
            map((response: NextPanel) => {
                return response;
            }),
        );
    }

    public getFinalize(): Observable<EnrollmentBenefitCategory> {
        return this.apiService.get(`${controllerRoute}/complete`).pipe(
            map((response: EnrollmentBenefitCategory) => {
                return response;
            }),
        );
    }
}